import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActionSystemViewModel, AvailableActionViewModel, ComponentOnSystemViewModel } from '../../action-models';
import { LoadingService } from '../../../../shared/services/loading.service';
import { ActionService } from '../../action.service.service';
import { SetupUndercarriageService } from '../../../setup-undercarriage/setup-undercarriage.service';

import { trigger, style, transition, animate, keyframes, query, stagger } from '@angular/animations';

@Component({
  selector: 'system-actions',
  templateUrl: './system-actions.component.html',
  styleUrls: ['./system-actions.component.scss'],
  animations: [
    trigger('fadeInList', [
      transition('* => *', [
        query(':enter', style({ opacity: 0 }), { optional: true }),
        query(':enter', stagger('500ms', [
          animate('.5s ease-in', keyframes([
            style({ opacity: 0, transform: 'translateY(-5%)', offset: 0 }),
            style({ opacity: 1, transform: 'translateY(0)', offset: 1.0 }),
          ]))]), { optional: true })
      ])
    ]),
    trigger(
      'fadeIn', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('500ms', style({ opacity: 1 }))
        ]),
        transition(':leave', [
          style({ opacity: 1 }),
          animate('500ms', style({ opacity: 0 }))
        ])
      ]
    )
  ],
})
export class SystemActionsComponent implements OnInit, OnChanges {

  @Input() systemType: number;
  @Input() side: number;
  @Input() equipmentId: number;
  
  @Output() selectedComponentAction = new EventEmitter();
  @Output() selectedSystemAction = new EventEmitter();
  @Output() unlockActions = new EventEmitter();


  @Output() systemInfoLoaded = new EventEmitter();
  imageUrl: string;
  systemTitle: string;
  loadingSystem = false;
  system: ActionSystemViewModel;

  // hard coded sorry
  systemActions: AvailableActionViewModel[] = [];

  // systemAction = false;
  // componentAction = false;

  selectedActionAgainstComponent: ComponentOnSystemViewModel;
  selectedActionAgainstSystem: ActionSystemViewModel;

  actionLocked: boolean;

  selectedAction: AvailableActionViewModel;

  FamilyImage_Chain: any = null;
  FamilyImage_Frame: any = null;


  //new code

  @Input() selectedActionInput:AvailableActionViewModel;
  @Input() selectedActionAgainstSystemInput:ActionSystemViewModel;
  @Input() isReplace:boolean;

  //end new code
  constructor(
    private _sanitizer: DomSanitizer,
    private _loadingService: LoadingService,
    private _actionService: ActionService,
    private _setupService: SetupUndercarriageService
  ) { }

  ngOnInit() {
    this.loadSystem();
    this.assignTitle();
    if(this.selectedActionInput !== undefined && this.selectedActionAgainstSystemInput !== undefined && this.isReplace==true){
      
      this.selectActionOnSystem(this.selectedActionInput);
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if (this.systemType !== undefined && this.side !== undefined && this.equipmentId !== undefined && this.isReplace==false) {
      this.loadSystem();
      this.assignTitle();
      this.getFamily();

    }
    if(this.selectedActionInput !== undefined && this.selectedActionAgainstSystemInput !== undefined && this.isReplace==true){
     
      this.selectActionOnSystem(this.selectedActionInput);
    }
  }
  loadSystem() {
    this._loadingService.startLoading();
    this.loadingSystem = true;
    this._actionService.GetActionSystemViews(this.equipmentId, this.systemType, this.side).subscribe((s: ActionSystemViewModel) => {
      this.loadingSystem = false;
      this._loadingService.finishedLoading();
      this.system = s;
      // filter front and rear if there is no component to swap
      // this.system.Components.find(c=>c.)
      this.systemInfoLoaded.emit(this.system);
    });
  }

  assignTitle() {
    if (this.systemType === 1) {
      this.imageUrl = '/Content/Images/chain.jpg';
      this.side === 1 ? this.systemTitle = 'Left Side Chain' :    this.systemTitle = 'Right Side Chain';
    }    else {
      this.imageUrl = '/Content/Images/frame.jpg';
      this.side === 1 ? this.systemTitle = 'Left Side Frame' :    this.systemTitle = 'Right Side Frame';
    }

    // if (this.systemType === 1) {
    //   this.systemActions = [
    //     new AvailableActionViewModel(34, `Replace ${this.systemType === 1 ? 'Chain' : 'Frame'} `),
    //   ];
    // }    else {
    //   this.systemActions = [
    //     new AvailableActionViewModel(34, `Replace ${this.systemType === 1 ? 'Chain' : 'Frame'} `),
    //     new AvailableActionViewModel(600, `Replace Multiple ${this.side === 1 ? 'Left' : 'Right'}  Components`),
    //   ];
    // }


  }

  getImage(image: string) {
    if (image != null && image !== undefined)
      return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }


  selectActionOnComponent(action: AvailableActionViewModel, component: ComponentOnSystemViewModel) {
   this.selectedActionAgainstComponent = component;
    this.selectedAction = action;
    // this.componentAction = true;
    this.selectedComponentAction.emit({actionModel: action, componentModel : component, systemModel: this.system });
  }

  selectActionOnSystem(action: AvailableActionViewModel) {
    console.log("action", action,this.selectedActionAgainstSystemInput)
    this.selectedActionAgainstSystem = this.selectedActionAgainstSystemInput;//this.system;
    this.selectedAction = action;
    // this.systemAction = true;
    this.selectedSystemAction.emit({ actionModel: action,  systemModel: this.selectedActionAgainstSystemInput });
  }


  disableAllActions() {
    this.actionLocked = true;
  }


  unlock() {
    this.unlockActions.emit();
  }

  reSelectActions() {
    this.selectedActionAgainstSystem = undefined;
    this.selectedActionAgainstComponent = undefined;
    this.selectedAction = undefined;
    this.actionLocked = false;
  }

  getFamily() {
      this._setupService.getEquipmentFamily(this.equipmentId).subscribe((r: any) => {
          if (r != null) {
              this.FamilyImage_Chain = r.ChainImage;
              this.FamilyImage_Frame = r.FrameImage;

              if (this.systemType === 1) {
                  if (this.FamilyImage_Chain != null) {
                      this.imageUrl = this.FamilyImage_Chain;
                  }
              } else {
                  if (this.FamilyImage_Frame != null) {
                      this.imageUrl = this.FamilyImage_Frame;
                  }
              }
          }
      });
  }

  goToStepTwo() {

  }
}
